export default __webpack_public_path__ + "static/media/logo-ae-homebox.8ceb8a95.svg";